export function priceFormat(price: number): string {
  // Split the price into dollars and cents
  return (price / 12).toFixed(2).toString();
}

// Format price to dollars and cents but don't show cents if they are zero
export function priceFormatNoCentsIfZero(
  price: number,
  displayAsMonthly = false,
  discountPercentage?: number
): string {
  const calculatedPrice = discountPercentage ? price - price * (discountPercentage / 100) : price;
  const priceString = (displayAsMonthly ? price / 12 : calculatedPrice).toFixed(2);
  return priceString.endsWith('.00') ? priceString.slice(0, -3) : priceString;
}
